import { OEBackend } from "@/graphql"

export const RunMeterPointPmaxAnalysisMutation = OEBackend.graphql(`
    mutation RunMeterPointPmaxAnalysis($input: RunMeterPointPMAXAnalysisInput!) {
        runMeterPointPmaxAnalysis(input: $input) {
            pmaxAnalysis {
                token
                recommendedSubscribedMaxPower
                yearlyProfitAmountCents
                currentSubscribedMaxPower
                firstName
                lastName
                suggestedPowerAdjustment
                krakenProductCode
                prmId
            }
        }
    }
`)
